import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { toast } from "sonner";
import { Trash2, Undo2 } from "lucide-react";
import { eur, dIt } from "@/components/FinanzaMese";
import { useAuth } from "@/context/AuthContext";
import { EliminaDefBtn, SvuotaCestinoBtn } from "@/components/CestinoDefinitivo";
import { BarraElenco, Casella, SelezionaTutto, azioniCestino, useSelezione } from "@/components/SelezioneFile";

const TIPI = { movimento: "Spesa", spesa_fissa: "Spesa fissa", provvigione: "Incasso", provvigione_collaboratore: "Provvigione collaboratore", fattura: "Fattura", scadenza_fiscale: "Scadenza fiscale", entrata: "Entrata", pulizia: "Backup pulizia" };
const giorni = (s) => Math.max(0, Math.ceil((new Date(s) - new Date()) / 86400000));

export default function FinanzaCestino() {
  const { isDirezione, isSegreteria } = useAuth();
  const isSoci = isDirezione || isSegreteria;
  const [list, setList] = useState(null);
  const S = useSelezione();
  const load = () => api.get("/finanza/cestino").then((r) => setList(r.data)).catch((e) => toast.error(apiError(e)));
  useEffect(() => { load(); }, []);
  const ripristina = async (r) => {
    try { await api.post(`/finanza/cestino/${r.id}/ripristina`); toast.success("Voce ripristinata"); load(); } catch (e) { toast.error(apiError(e)); }
  };
  return (
    <div data-testid="finanza-cestino">
      <div className="flex items-center gap-3 flex-wrap mb-4">
        {list?.length > 0 && <SelezionaTutto ids={list.map((r) => r.id)} sel={S.sel} onTutti={S.tutti} testid="finanza-cestino-seltutto" />}
        <p className="text-sm text-[var(--muted)] flex-1">Le voci eliminate restano qui per 30 giorni, poi vengono cancellate definitivamente.</p>
        {isSoci && <SvuotaCestinoBtn ambito="finanza" count={list?.length || 0} onDone={load} />}
      </div>
      {!list ? <div className="skeleton h-40 rounded-2xl" /> : list.length === 0 ? (
        <div className="card-immo p-8 text-center text-sm text-[var(--muted)]" data-testid="cestino-vuoto"><Trash2 className="mx-auto mb-2 opacity-40" /> Il cestino è vuoto.</div>
      ) : (
        <div className="card-immo divide-y divide-[var(--border)]">
          <BarraElenco sel={S.sel} onAnnulla={S.annulla} onFatto={load}
            azioni={azioniCestino((id) => api.post(`/finanza/cestino/${id}/ripristina`), isSoci ? (id) => api.post(`/cestino/finanza/${id}/elimina-definitivo`, { conferma: "ELIMINA" }) : null)} />
          {list.map((r) => (
            <div key={r.id} data-testid={`cestino-${r.id}`} className={`flex items-center gap-3 flex-wrap p-4 ${S.sel.has(r.id) ? "bg-[#FC82ED]/10" : ""}`}>
              <Casella inline on={S.sel.has(r.id)} onToggle={() => S.toggle(r.id)} testid={`cestino-sel-${r.id}`} />
              <div className="min-w-0 flex-1">
                <div className="text-sm font-semibold">{r.label}</div>
                <div className="text-[11px] text-[var(--muted)]">{TIPI[r.tipo] || r.tipo}{r.data ? ` · ${dIt(r.data)}` : ""}{r.collegati ? ` · +${r.collegati} voci collegate` : ""} · eliminata il {dIt(r.deleted_at)} da {r.deleted_by} · {giorni(r.scade_il)} giorni rimasti</div>
              </div>
              {r.importo != null && <div className="mono font-semibold text-sm">{eur(r.importo)}</div>}
              <div className="flex gap-2">
                <button data-testid={`cestino-ripristina-${r.id}`} onClick={() => ripristina(r)} className="flex items-center gap-1 px-3 py-1.5 rounded-lg bg-white border border-[var(--border)] text-xs font-semibold hover:border-[#FC82ED]"><Undo2 size={13} /> Ripristina</button>
                {isSoci && <EliminaDefBtn ambito="finanza" id={r.id} onDone={load} testid={`cestino-definitivo-${r.id}`} />}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
